import z from 'zod';
import { isValidObjectId } from '../../../../helperFunctions';
import { zodRedirectSchema } from '../../../../Validators';
import { callbackMethods } from '../../../../../constants';

export const postbackSchema = z
  .object({
    _id: z
      .string({
        required_error: 'Supplier ID is required',
        invalid_type_error: 'Default Supplier ID must be a string',
      })
      .trim()
      .refine(isValidObjectId, {
        message: 'Invalid ObjectId for Supplier ID',
      }),
    serverCallback: z
      .boolean({
        required_error: 'Server callback value is required.',
        invalid_type_error: 'Expected boolean value for Server callback.',
      })
      .optional(),
    routing: z
      .boolean({
        required_error: 'Routing value is required.',
        invalid_type_error: 'Expected boolean value for Routing.',
      })
      .optional(),
    serverCallbackEndpoints: zodRedirectSchema.optional(),
    serverCallbackMethod: z
      .enum(callbackMethods, {
        required_error: 'Callback method is required.',
        invalid_type_error: 'Please select a valid callback method.',
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.serverCallback) {
      if (!data.serverCallbackMethod) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['serverCallbackMethod'],
          message:
            'Callback method is required when server callback is enabled.',
        });
      }

      if (!data.serverCallbackEndpoints) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['serverCallbackEndpoints'],
          message:
            'Postback endpoints are required when server callback is enabled.',
        });
      }
    }

    if (data.routing && !data.serverCallback) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['routing'],
        message: 'Enable server callback before enabling routing.',
      });
    }
  });
